<template>
    <div id="smallImage">
        <div class="csthumbnai" v-for="(item, index) in seriesList" @mouseover="showDelete(index)" @mouseout="hideDelete(index)">
            <div class="delete" v-if="flag">
                <i class="el-icon-zoom-in iconZ" title="大图查看" @click="showBig(index)"></i>
                <i class="el-icon-close iconD" title="删除" @click='deleteImage(index)'></i>
            </div>
        </div>
        <el-dialog title="大图查看" :visible.sync="bigImage" width="80%" center @close="close()" append-to-body>
            <p>总计：{{number}}张</p>
            <div class="csBigImage">
                <div class="listItem"  v-for="(item, index) in imageList.instances"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as cornerstone from "../../../static/dist/cornerstone.js";
import * as dicomParser from "../../../static/dist/dicomParser.js"

import * as cornerstoneWADOImageLoader from "../../../static/dist/cornerstoneWADOImageLoader.js";

import Hammer from "../../../static/dist/hammer.js";
import * as cornerstoneMath from "../../../static/dist/cornerstoneMath.js";
import * as cornerstoneTools from "../../../static/dist/cornerstoneTools.js";

cornerstoneTools.external.Hammer = Hammer;
cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstone.registerImageLoader("http", cornerstoneWADOImageLoader.loadImage);
cornerstone.registerImageLoader("https", cornerstoneWADOImageLoader.loadImage);
//配置 webWorker (必须配置)
//注意这里的路径问题  如果路径不对 cornerstoneWADOImageLoaderWebWorker 会报错 index.html Uncaught SyntaxError: Unexpected token <
// var config = {
//     webWorkerPath: "../../../static/dist/cornerstoneWADOImageLoaderWebWorker.js",
//     taskConfiguration: {
//         decodeTask: {
//             codecsPath: "../../../static/dist/cornerstoneWADOImageLoaderCodecs.js"
//         }
//     }
// };
// cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
export default {
    name:'smallImage',
    data(){
        return{
            // baseUrl:"https://new-yingxiang.oss-cn-beijing.aliyuncs.com/",
            baseUrl:"https://yx.huayiyun.net/oss/",
			// baseUrl:"https://oss.huayiyun.net/",
            // baseUrl:"",
            bigImage:false,
            imageList:'',
            number:0,
            flagT:false,
            hospId:''
            // seriesList: "", //包含序列信息的图像集，从后台获取
        }
    },
    props:['seriesList','flag','idDetail'],
    computed:{
        ...mapState(['imageFlag'])
    },
    mounted(){
        // this.imageList='';
        this.show();
        let caseMsg=this.$common.getStorage('caseMsg');
        caseMsg.belongHospId!=undefined?this.hospId=caseMsg.belongHospId:this.hospId=caseMsg.applyHospId
    },
    methods:{
        //图像初始化
        show() {
            this.$nextTick(() => {
                var el=$('.csthumbnai')
                for(var i=0;i<el.length;i++){
                    $('.csthumbnai').eq(i).find('.delete').hide();
                }
                var csthumbnais = document.getElementsByClassName("csthumbnai");
                for (var i = 0; i < csthumbnais.length; i++) {
                    let canvas = csthumbnais[i];
                    cornerstone.enable(canvas);
                    let imageIds = this.seriesList[i].instances;
                    let imageUrl = this.baseUrl+this.seriesList[i].instances[0].dicomUrl;
                    let imageId = "wadouri:" + imageUrl;
                    let _this = this;
                    let _num = i;
                    //  Load & Display
                    cornerstone.loadAndCacheImage(imageId).then(
                        function (image) {
                            // 设置元素视口
                            var viewport = cornerstone.getDefaultViewportForImage(
                                canvas,
                                image
                            );
                            if(_this.hospId=='ba13995317bf4b63b97e7451fe17754d'){
                                viewport.voiLUT = undefined;
                            }
                            _this.seriesList[_num].instances = _this.framesJudge(image,imageIds,_this.seriesList[_num].instances[0].dicomUrl,_this.seriesList[_num].instances[0].dicomId)
                            // 显示图像
                            cornerstone.displayImage(canvas, image, viewport);
                        },
                        function (err) {
                            console.log(err);
                        }
                    );
                }
            })
        },
        //点击大图查看
        showBig(index){
            this.imageList=this.seriesList[index];
            this.number=this.imageList.instances.length;
            let _this=this;
            this.$nextTick(() => {
                var csthumbnais = document.getElementsByClassName("listItem");
                for (var i = 0; i < csthumbnais.length; i++) {
                    let canvas = csthumbnais[i];
                    cornerstone.enable(canvas);
                    let imageUrl = this.baseUrl+this.imageList.instances[i].dicomUrl;
                    let imageId = "wadouri:" + imageUrl;

                    
                    //  Load & Display
                    cornerstone.loadAndCacheImage(imageId).then(
                        function (image) {
                            // 设置元素视口
                            var viewport = cornerstone.getDefaultViewportForImage(
                                canvas,
                                image
                            );
                            if(_this.hospId=='ba13995317bf4b63b97e7451fe17754d'){
                                viewport.voiLUT = undefined;
                            }
                            // 显示图像
                            cornerstone.displayImage(canvas, image, viewport);
                        },
                        function (err) {
                            console.log('%c '+err,'color:red');
                        }
                    );
                }
            });
            this.bigImage=true;
        },
        //大图查看
        bigDiag(index){
            // this.$common.setStorage('imageList',this.seriesList[index]);
            // let routeData = this.$router.resolve({
            //     path: '/bigImage',
            // });
            // window.open(routeData.href, '_blank');
        },
        //鼠标悬浮，显示删除按钮
        showDelete(index){
            $('.csthumbnai').eq(index).find('.delete').show();
        },
        //鼠标离开，隐藏悬浮按钮
        hideDelete(index){
            $('.csthumbnai').eq(index).find('.delete').hide();
        },
        //删除影像序列
        deleteImage(index){
            window.event? window.event.cancelBubble = true : e.stopPropagation();
            this.$store.state.deleteImage=index;
        },
        //关闭大图查看
        close(){
            this.imageList='';
        },
        //多帧处理
        framesJudge(image,imageIds,dicomUrl,dicomId){
            // 显示图像
            try{
                if(image.data.elements.x52009230) {
                    var perFrameFunctionalGroupsSequenceElm = image.data.elements.x52009230;
                    if (perFrameFunctionalGroupsSequenceElm.items && perFrameFunctionalGroupsSequenceElm.items.length > 0) {
                        if (imageIds.length !== perFrameFunctionalGroupsSequenceElm.items.length) {
                            if (perFrameFunctionalGroupsSequenceElm.items[perFrameFunctionalGroupsSequenceElm.items.length - 1].tag === "xfffee000") {
                                var baseSeriesURL = dicomUrl;
                                imageIds = [];
                                var imageItem = imageIds[0]
                                perFrameFunctionalGroupsSequenceElm.items.forEach(function (value, index) {
                                    let item = {
                                        ...imageItem
                                    }
                                    baseSeriesURL=baseSeriesURL.split('?')[0];
                                    item.dicomUrl = baseSeriesURL + "?frame=" + index
                                    item.dicomId = dicomId;
                                    imageIds.push(item);
                                });
                            } else {
                            }
                        }
                    }
                }
            }catch(e){
                console.info(e.message);
            }
            return imageIds
        }
    },
    watch:{
        //监听渲染影像
        imageFlag(val){
            // console.log(val)
            if(val){
                this.show();
                this.$store.state.imageFlag=false;
            }
        },
        idDetail(val){
            if(val){
                this.show();
                this.idDetail='';
            }
        }
    }
}
</script>

<style>
*{
    margin:0;
    padding:0
}
#smallImage{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.csthumbnai {
    color: white;
    background-color: black;
    width: 100px;
    height: 100px;
    outline: 1px solid rgb(156, 153, 153);
    padding: 0px;
    margin:5px;
    position: relative;
    display: block;
}
.delete{
    position: absolute;
    width:100px;
    height:100px;
    line-height: 100px;
    text-align: center;
    font-size: 16px;
    background-color: rgba(0,0,0,0.65);
    top:0px;
    left:0;
    z-index: 10;
}
.iconZ{
    /* height:60px;
    width:60px; */
    line-height: 100px;
    cursor: pointer;
    font-size:40px;
}
.iconD{
    position: absolute;
    top:2px;
    right:2px;
    cursor: pointer;
    font-size: 20px;
}
.iconZ:hover{
    color:#5EBEF9
}
.iconD:hover{
    color:red
}
.csBigImage{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-bottom:20px;
}
.listItem{
    color: white;
    background-color: black;
    width: 300px;
    height: 300px;
    outline: 1px solid rgb(156, 153, 153);
    padding: 0px;
    margin:5px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Viewm/smallImage.vue